<p-table [value]="allPurchaseSubmodule" dataKey="id">
    <ng-template pTemplate="header">
      <tr>
        <th style="max-width: 3rem"></th>
        <th>Name</th>
        <th>Status</th>
        <th>Is Active</th>
        <th>Is Default</th>
        <th>Action</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product let-i="rowIndex" let-expanded="expanded">
      <tr class="parentRow">
        <td class="action">
          <button type="button" [pRowToggler]="product" pButton pRipple
            class="p-button-text p-button-rounded p-button-plain"
            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
            *ngIf="product?.stages && product?.stages?.length > 0" style="width: 20px;height: 20px;"></button>
        </td>
        <td>{{product?.displayName}}</td>
        <td>
          <span *ngFor="let statusData of product?.status;let i = index;">
            {{statusData?.statusTypeName}}<span *ngIf="product?.status?.length > i+1">,</span>
          </span>
        </td>
        <td>
            <span *ngIf="product?.isActive">Yes</span>
            <span *ngIf="!product?.isActive">No</span>
        </td>
        <td>
          <p-radioButton [disabled]="!product.isActive" [value]="true" [(ngModel)]="product.isDefault"
            (onClick)="eventCalled(product)"></p-radioButton>
            <span *ngIf="product?.isDefault"> Yes</span>
            <span *ngIf="!product?.isDefault"> No</span>
        </td>
        <td></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-product>
      <ng-container *ngFor="let child of product?.stages">
        <tr>
          <td></td>
          <td style="padding-left: 2rem !important;">{{child?.name}}</td>
          <td>
            <span *ngFor="let childStatusData of child?.status;let i = index;">
              <ng-container *ngIf="childStatusData?.isActive">
                {{childStatusData?.name}}<span *ngIf="child?.status?.length > i+1">,</span>
              </ng-container>
            </span>
          </td>
          <td>
            <span *ngIf="child?.isActive">Yes</span>
            <span *ngIf="!child?.isActive">No</span>
          </td>
          <td>
            <span *ngIf="child.isDefault">Yes</span>
            <span *ngIf="!child.isDefault">No</span>
          </td>
          <td class="action">
            <span class="btnBars p-mr-0" (click)="showEditStatus(product,child)"
            pTooltip="Edit" tooltipPosition="top"><i class="pi pi-pencil"></i></span>
          </td>
        </tr>
      </ng-container>
    </ng-template>
  </p-table>

<p-dialog header="Edit Status" [(visible)]="displayEditPurchaseStatus" [modal]="true" [responsive]="true"
  [style]="{width: '60vw'}">
  <div class="header">
   <h5>Status Information</h5>
  </div>
  <div class="card">
    <div class="p-field p-formgrid p-grid">
       <div class="p-col-12 p-lg-6">
         <label>Stage Name <span style="color: red;">*</span></label>
         <input type="text" pInputText [(ngModel)]="purchaseSubmoduleStageTemp.templateName" disabled>
       </div>
       <div class="p-col-12 p-lg-6">
         <label>Status Name <span style="color: red;">*</span></label>
         <input type="text" pInputText [(ngModel)]="purchaseSubmoduleStageTemp.stageName" disabled>
       </div>
    </div>
    <div class="p-field p-formgrid p-grid">
      <div class="p-col-12">
        <p-pickList [source]="sourceStatusList" [target]="targetStatusList" sourceHeader="Selected"
        targetHeader="Available" [dragdrop]="true" [responsive]="true" [sourceStyle]="{'height':'300px'}"
        [targetStyle]="{'height':'300px'}">
          <ng-template let-product pTemplate="item">
              <div class="product-item">
                  <div class="product-list-detail">
                      <h5 class="p-mb-2">{{product.name}}</h5>
                  </div>
              </div>
          </ng-template>
        </p-pickList>
      </div>
    </div>
  </div>
  <p-footer>
    <button type="button" pButton (click)="displayEditPurchaseStatus=false" label="Cancel"
      class="p-button-secondary"></button>
      <button type="button" pButton (click)="savePurchaseStatus()" label="Save"></button>
  </p-footer>
</p-dialog>

